<p-toast position="top-center">
  <!-- Custom message template so `detail` can render inline HTML (e.g. a bold
       follow-up line), which PrimeNG's default template only ever interpolates
       as escaped text. -->
  <ng-template let-message pTemplate="message">
    <span
      class="p-toast-message-icon pi"
      [ngClass]="{
        'pi-check': message.severity === 'success',
        'pi-info-circle': message.severity === 'info' || message.severity === undefined,
        'pi-times-circle': message.severity === 'error',
        'pi-exclamation-triangle': message.severity === 'warn'
      }"
      aria-hidden="true"
    ></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail" [innerHTML]="message.detail"></div>
    </div>
  </ng-template>
</p-toast>

<div class="app-loading" *ngIf="loading$ | async">
  <app-spinner [fill]="false" />
</div>

<app-header
  [profile]="headerProfile"
  [showLogout]="showHeaderLogout"
  (logout)="onLogout()"></app-header>

<div class="block w-full flex-1 overflow-y-auto">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>

<!-- App Popup Component -->
<app-popup></app-popup>